import React, { useState, useEffect } from "react";
import "./componentstyle/heroSection.css";
import { FiArrowRight } from "react-icons/fi";
import heroImg1 from "../assets/hero-img-1.jpg";
import heroImg2 from "../assets/hero-img-2.jpg";

const HeroSection = () => {
  const images = [heroImg1, heroImg2];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="hero-section">
      <img
        src={images[currentImageIndex]}
        alt="Hero background"
        className="hero-image"
      />
      <div className="hero-content">
        <h1>
          The Best Export
          <br />
          Company in Town
        </h1>
        <p>One Of The Oldest And Most Reputed Importers</p>
        <div className="learn-more-btn d-none">
          <span className="icon-circle">
            <FiArrowRight />
          </span>
          <span>Learn more</span>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;

// import React, { useState, useEffect } from "react";
// import "./componentstyle/heroSection.css";
// import { FiArrowRight } from "react-icons/fi";
// import heroImg1 from "../assets/hero-img-1.jpg";
// import heroImg2 from "../assets/hero-img-2.jpg";

// const HeroSection = () => {
//   const images = [heroImg1, heroImg2];
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [previousIndex, setPreviousIndex] = useState(0);
//   const [isAnimating, setIsAnimating] = useState(false);

//   useEffect(() => {
//     const interval = setInterval(() => {
//       setPreviousIndex(currentIndex);
//       setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
//       setIsAnimating(true);

//       setTimeout(() => setIsAnimating(false), 3000); // same as animation duration
//     }, 5000);

//     return () => clearInterval(interval);
//   }, [currentIndex, images.length]);

//   return (
//     <div className="hero-section-container">
//       <div
//         className={`hero-section slide-out`}
//         style={{ backgroundImage: `url(${images[previousIndex]})` }}
//       />
//       <div
//         className={`hero-section slide-in ${isAnimating ? "animating" : ""}`}
//         style={{ backgroundImage: `url(${images[currentIndex]})` }}
//       >
//         <div className="hero-content">
//           <h1>
//             The Best Export
//             <br />
//             Company in Town
//           </h1>
//           <p>One Of The Oldest And Most Reputed Importers</p>
//           <div className="learn-more-btn">
//             <span className="icon-circle">
//               <FiArrowRight />
//             </span>
//             <span>Learn more</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default HeroSection;
